import React, { Component, createRef } from "react";
import "../component/Landing.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Empty from "../image/empty.svg";
import DateDisplay from "./user/dateformate";

class ScrollCourse extends Component {
    constructor(props) {
        super(props);
        this.landingSlideRef = createRef();
        this.landingContentsRef = createRef();

        this.state = {
            topic: "",
            slidePosition: 0,
            nextButtonDisabled: false,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.topics !== prevState.topic) {
            return {
                topic: nextProps.topics,
            };
        }
        return null;
    }

    componentDidMount() {
        this.calculateSlideWidth();
        const topic = this.props.topics;
        if (topic) {
            this.setState({ topic });
        }

        this.addWheelScrollSupport(); // keep this to allow scroll with wheel/trackpad
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.topic.length !== this.state.topic.length) {
            this.calculateSlideWidth();
        }
    }

    calculateSlideWidth() {
        const landingSlideRef = this.landingSlideRef.current;
        const landingContentsRef = this.landingContentsRef.current;

        if (landingSlideRef && landingContentsRef && this.state.topic.length > 0) {
            const topicWidth = landingSlideRef.children[0].offsetWidth;
            const topicMargin = 20;
            const totalTopicWidth = this.state.topic.length * (topicWidth + topicMargin);
            landingSlideRef.style.width = `${totalTopicWidth + 100}px`;
        }
    }

    handleNexts = () => {
        const landingSlideRef = this.landingSlideRef;
        const landingContentsRef = this.landingContentsRef;

        if (landingSlideRef.current && landingContentsRef.current) {
            const topicWidth = landingSlideRef.current.children[0].offsetWidth + 20;
            const containerWidth = landingContentsRef.current.offsetWidth;
            const totalCourses = this.state.topic.length;
            const totalSlideWidth = totalCourses * topicWidth;
            const maxSlidePosition = totalSlideWidth - containerWidth;
            const stepSize = Math.floor(containerWidth / topicWidth) * topicWidth;

            const newPosition = Math.min(this.state.slidePosition + stepSize, maxSlidePosition);
            this.setState({
                slidePosition: newPosition,
                nextButtonDisabled: newPosition >= maxSlidePosition,
            });
        }
    };

    handlePrevs = () => {
        const landingSlideRef = this.landingSlideRef;
        const landingContentsRef = this.landingContentsRef;

        if (landingSlideRef.current && landingContentsRef.current) {
            const topicWidth = landingSlideRef.current.children[0].offsetWidth + 20;
            const containerWidth = landingContentsRef.current.offsetWidth;
            const stepSize = Math.floor(containerWidth / topicWidth) * topicWidth;

            const newPosition = Math.max(this.state.slidePosition - stepSize, 0);
            this.setState({
                slidePosition: newPosition,
                nextButtonDisabled: false,
            });
        }
    };

    handleDelete = (list) => {
        this.props.onDelete(list);
    };

    handlecoursetype = (field) => {
        if (
            field === "Online Prerecorded" ||
            field === "Online Live" ||
            field === "Online Live with Facilitator"
        ) {
            return "Online";
        } else {
            return "Physical";
        }
    };

    // ✅ Horizontal scroll support with mouse wheel
    addWheelScrollSupport = () => {
        const el = this.landingContentsRef.current;
        if (!el) return;

        el.addEventListener("wheel", (e) => {
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                e.preventDefault();
                el.scrollLeft += e.deltaY;
            }
        }, { passive: false });
    };

    render() {
        const topics = this.state.topic;

        function slugify(text) {
            return text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
        }

        const course_list = topics?.length ? (
            topics.map((list) => (
                <div className="hover" key={list.id}>
                    <section className="landing_topic animate">
                        <Link to={`/Landing_description/${list.id}/${slugify(list.title)}`}>
                            <div className="course_video">
                                <img src={list.thumbnail} alt={"course image" + list.id} />
                                <div className="time">
                                    <DateDisplay data={list.duration} />
                                </div>
                            </div>
                            <div className="course_Writeup">
                                <h4>
                                    <span>{list.labels} - {list.tags} </span>
                                    <span
                                        className="right"
                                        style={{
                                            color:
                                                this.handlecoursetype(list.training_type) === "Online"
                                                    ? "rgb(1, 174, 95)"
                                                    : "blue",
                                        }}
                                    >
                                        {this.handlecoursetype(list.training_type)}
                                    </span>
                                    <br />
                                    {list.title}
                                </h4>
                                <p className="content">
                                    {list.training_type}
                                    {["Online Prerecorded", "Online Live", "Online Live with Facilitator"].includes(list.training_type) ? " class" : null}
                                </p>
                                <p className="content">Location - Lagos and Abuja </p>
                            </div>
                        </Link>
                    </section>
                </div>
            ))
        ) : (
            <div className="no_course">
                <div className="image"><img src={Empty} alt="no course" /></div>
                <br />
                <p>No Available Course </p>
            </div>
        );

        const slideStyle = {
            transform: `translateX(-${this.state.slidePosition}px)`,
            transition: "transform 0.4s ease-in-out",
            display: "flex",
            gap: "20px"
        };

        return (
            <div className="landing_scroll">
                <h3>
                    {this.props.headline}
                    <button onClick={this.handleNexts} disabled={this.state.nextButtonDisabled}>
                        <FaAngleRight />
                    </button>
                    <button onClick={this.handlePrevs}><FaAngleLeft /></button>
                </h3>

                <div
                    className="landing_scroll_button"
                    ref={this.landingContentsRef}
                    style={{
                        // overflowX: "auto",
                        scrollBehavior: "smooth",
                    }}
                >
                    <div
                        className="dash landing_slide"
                        ref={this.landingSlideRef}
                        style={slideStyle}
                    >
                        {course_list}
                    </div>
                </div>
            </div>
        );
    }
}

export default ScrollCourse;
